import { throttle } from 'throttle-debounce';

function setHeight() {
	const height = this.refs.container.clientHeight;
	this.setState({ height });
}

function onMouseMoveHandler(e) {
	e.persist();
	throttle(200, onMouseMove.call(this, e));
}

function onMouseMoveNoThrottle(e) {
	// console.log('aaaaa');
	const pageHeight = this.state.height;
	const mouseHeight = e.nativeEvent.clientY;
	const calculated = mouseHeight / pageHeight + 0.1;
	const opacity = calculated < 0.3 ? 0.3 : calculated;
	this.setState({ opacity });
}

const onMouseMove = throttle(200, onMouseMoveNoThrottle);

export { setHeight, onMouseMove, onMouseMoveHandler };



// WEBPACK FOOTER //
// ./src/utils/mouseEvents.js